/**
 * These hooks are wired into the global setInterval that runs 1x per second
 * (when the app is not suspended).
 *
 * These hooks work fine from non-observer components.
 */
import React from 'react'

import { useMst } from '#state/MstContext'

export const useThrottledNow = (intervalSeconds?: number) => {
  const { appStatus } = useMst()
  const [now, setNow] = React.useState(() => appStatus.now)

  React.useEffect(() => {
    const id = appStatus.registerTimeListener({
      cb: (now) => {
        setNow(now)
      },
      intervalSeconds,
    })

    return () => appStatus.removeTimeListener(id)
  }, [appStatus, intervalSeconds])

  return now
}
